export const environment = {
  production: false,
  local: false,
  URL_BASE: 'https://famulusbackend.rrsolutionstest.it/api/v1/client',
  URL_IMAGES: 'https://famulusimages.rrsolutionstest.it/',
  COOKIE_DOMAIN: '.rrsolutionstest.it',
  MEETING_URL: '',
  MEETING_URL2: '',
  MEETING_URL3: '',
  turnstileSiteKey: '0x4AAAAAACTPRDDfaielARd7',
  captchaSiteKey: '6Le5zIUsAAAAAFmkB2NZUv1r_ChDjVxPM2KuQPSJ'
};
